import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Blog from "../blogs/blog";
import LogOutIcon from "./Icons/logOutIcon";
import { auth } from "../firebase/firebase";
import { signOut } from "firebase/auth";
import Employee from "./Icons/employee";
import UserIcon from "./Icons/userIcon";

const data = [
  { title: "Dashboard", to: "/dashboard", icon: <Employee /> },
  { title: "Blog Posting", to: "/blogs", icon: <Blog /> },
  { title: "Contact List", to: "/contactlist", icon: <UserIcon /> },
];

const Sidebar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isContactListActive = location.pathname === "/contactlist";
  const isBlogActive =
    location.pathname === "/blogs" || location.pathname.startsWith("/blog");

  const handleSignOut = async () => {
    try {
      signOut(auth);
    } catch (error) {
      console.error("Error signing out:", error.message);
    } finally {
      setIsModalOpen(false);
    }
  };

  return (
    <div className="!w-[280px] h-screen fixed bg-white py-[34px] px-4 flex flex-col  border-r border-[#E4E7EC] ">
      <h1 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 via-blue-400 to-blue-800 hover:scale-105 transform transition duration-300 ease-in-out mt-4">
        Portfolio Admin
      </h1>

      <div className="flex-1 mt-6">
        <ul className="space-y-4 mt-5">
          {data.map((item, index) => (
            <li key={index}>
              <Link
                to={item.to}
                className={`flex items-center p-2 py-2 rounded-md transition duration-300 ease-in-out ${
                  (item.to === "/contactlist" && isContactListActive) ||
                  (item.to === "/blogs" && isBlogActive) ||
                  location.pathname === item.to
                    ? "bg-customblue text-white"
                    : "text-gray-700 hover:bg-blue-100 hover:text-blue-600"
                }`}
              >
                {item.icon}
                <span className="text-sm font-medium pl-3">{item.title}</span>
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex mt-5">
        <button
          className="flex items-center justify-center border-2 border-transparent bg-customblue hover:bg-blue-700 text-white rounded-md px-3 py-2 cursor-pointer transition duration-300 ease-in-out"
          onClick={() => setIsModalOpen(true)}
        >
          <LogOutIcon />
          <span className="ml-2">Sign Out</span>
        </button>
      </div>

      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-lg w-80 p-6">
            <h2 className="text-lg font-semibold text-gray-800">
              Are you sure you want to sign out?
            </h2>
            <div className="mt-4 flex justify-end space-x-4">
              <button
                onClick={() => setIsModalOpen(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                No
              </button>
              <button
                onClick={handleSignOut}
                className="px-4 py-2 bg-blue-700 text-white rounded hover:bg-blue-800 "
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
